import React, { useState, useMemo } from 'react';
import { Card, Tabs, Tab, Box, Grid, Divider } from '@mui/material';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { grey } from '@mui/material/colors';

import { useVisibility } from 'context/visibilityContext';

import OfferingGeneralInfo from './OfferingGeneralInfo';
import OfferingDiscounts from './OfferingDiscounts';
import OfferingIncludedProducts from './OfferingIncludedProducts';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`offering-details-tabpanel-${index}`}
      aria-labelledby={`offering-details-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `offering-details-tab-${index}`,
    'aria-controls': `offering-details-tabpanel-${index}`,
  };
}

function OfferingDetailsView({ product, onClose }) {
  const [tabValue, setTabValue] = useState(0);
  const { visibilityConfig } = useVisibility();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const cpqDiscountScheduleFields = useMemo(() => {
    const configSource = visibilityConfig.cpq;
    const config = Array.isArray(configSource)
      ? configSource.find((obj) => obj.objectName === 'SBQQ__DiscountSchedule__c')
      : undefined;
    return config?.displayColumns ? config.displayColumns.split(',').map((s) => s.trim()) : [];
  }, [visibilityConfig]);

  // --- THIS IS THE CORRECT renderFields FUNCTION ---
  const renderFields = (fields) => {
    if (!fields || Object.keys(fields).length === 0) {
      return (
        <ArgonTypography variant="caption" color="textSecondary" sx={{ fontStyle: 'italic', mb: 2 }}>
          No additional details available.
        </ArgonTypography>
      );
    }
    return (
      <ArgonBox mb={2}>
        {Object.entries(fields).map(([key, value]) => (
          <ArgonBox key={key} mb={1} width="100%">
            <Grid container alignItems="center" spacing={0}>
              <Grid item xs={7}>
                <ArgonTypography
                  variant="caption"
                  fontWeight="bold"
                  color="textSecondary"
                  align="left"
                  sx={{ wordWrap: 'break-word', color: grey[700] }}
                  ml={3}
                >
                  {key}
                </ArgonTypography>
              </Grid>
              <Grid item xs={1} style={{ textAlign: 'center' }}>
                <Divider orientation="vertical" flexItem />
              </Grid>
              <Grid item xs={3} style={{ textAlign: 'center' }}>
                <ArgonBox
                  bgcolor={grey[200]}
                  color={grey[700]}
                  p={1}
                  borderRadius="md"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ width: '100%', boxSizing: 'border-box' }}
                >
                  <ArgonTypography variant="caption" fontWeight="bold" sx={{ wordWrap: 'break-word', width: '100%' }}>
                    {String(value) || '-'}
                  </ArgonTypography>
                </ArgonBox>
              </Grid>
            </Grid>
          </ArgonBox>
        ))}
      </ArgonBox>
    );
  };

  return (
    <Card>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="offering details tabs">
          <Tab label="General Info" {...a11yProps(0)} />
          <Tab label="Included Products" {...a11yProps(1)} />
          <Tab label="Discounts" {...a11yProps(2)} />
        </Tabs>
      </Box>

      <ArgonBox p={3}>
        <TabPanel value={tabValue} index={0}>
          <OfferingGeneralInfo product={product} />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <OfferingIncludedProducts product={product} />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <OfferingDiscounts
            product={product}
            renderFieldsProp={renderFields}
            basicFields={cpqDiscountScheduleFields}
          />
        </TabPanel>
      </ArgonBox>
    </Card>
  );
}

export default OfferingDetailsView;
